import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '@/components/DialogTitle';

/**
 * プロパティ
 */
export type Props = {
  /** 保存せず閉じる */
  close: () => void,
  /**
   * 閉じる
   * @returns なし
   */
  cancel: () => void,
};

const ConfirmClose: React.FC<Props> = ({
  close,
  cancel,
}) => (
  <Dialog
    open
    onClose={() => cancel()}
  >
    <DialogTitle title="連絡帳" />
    <DialogContent>
      <p>入力した内容が破棄されますがよろしいですか？</p>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={() => close()}
        color="primary"
        startIcon={<DeleteIcon />}
      >
        破棄する
      </Button>
      <Button variant="contained" onClick={() => cancel()} color="primary">
        キャンセル
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmClose;
